import Loader from "./Loader";

const ConfirmPrompt = ({ message, onConfirm, onCancel, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg border border-ase-blue w-full md:w-auto max-w-[600px]">
        <h2 className="text-lg font-semibold bg-ase-blue py-2 px-4 text-white">
          Confirm Action
        </h2>

        <div className="p-6 flex items-center justify-center">
          <Loader isSmall={true} />
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-auto md:max-w-[600px]">
      <h2 className="text-lg font-semibold bg-ase-blue py-2 px-4 text-white">
        Confirm Action
      </h2>

      <div className="px-4 py-2">
        <p className="font-semibold mb-3 text-sm">{message}</p>

        <div className="flex items-center gap-2">
          <button
            className="bg-ase-blue text-white font-semibold px-2 py-1 text-sm rounded-md"
            onClick={onConfirm}
          >
            Confirm
          </button>

          <button
            className="border border-ase-blue text-ase-blue font-semibold px-2 py-1 text-sm rounded-md"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmPrompt;
